<form (submit)="find()">
    <input type="text" name="query" [(ngModel)]="query" />
    <input type="number" inputmode="numeric" name="limit" [(ngModel)]="limit" min="1" max="100" />
    <input type="submit" value="find" />
    <input type="button" value="analyse" (click)="analyse()" />
</form>
<div *ngFor="let link of links">
    <a [href]="link.Url" style="text-decoration: none">{{link.Text}}</a>
</div>
<table *ngIf="result">
    <tr>
        <th>Phrase</th>
        <th>Score</th>
    </tr>
    <tr *ngFor="let item of result">
        <td>{{item.Key}}</td>
        <td>{{item.Value|number}}</td>
    </tr>
</table>